import styled from 'styled-components';

export const TextBlockStyle = styled.div`
    font-size: 1.2rem;
`;
